import { AppShell, Box, Center, Loader, Stack } from '@mantine/core'
import { User } from '@ospace/auth'
import { userTypes } from '@ospace/core-auth'
import { Client } from '@ospace/schemas'
import { Notifications } from '@mantine/notifications'
import { ReactElement } from 'react'

import { useSideNav } from '../hooks/useSideNav'
import classes from './ClientPageLayout.module.css'
import { CustomHeader } from './CustomHeader'
import { Footer } from './Footer'
import { PageId, SideNavbar } from './SideNavbar'

type Props =
  | {
      status: 'ready'
      pageId: PageId
      children: ReactElement
      user: User
      role: userTypes
      client: Client
      subHeader?: ReactElement
      pageTitle?: string
      fluid?: boolean
    }
  | {
      status: 'loading'
      pageId: PageId
      user?: User
      role: userTypes
      client?: Client
      pageTitle?: string
      subHeader?: ReactElement
      fluid?: boolean
    }
  | {
      status: 'error'
      pageId: PageId
      user?: User
      role: userTypes
      client?: Client
      pageTitle?: string
      subHeader?: ReactElement
      fluid?: boolean
      message: string
    }

export const ClientPageLayout = (props: Props) => {
  const { opened, setOpened } = useSideNav()
  // const SideNavBarWidth = opened ? { base: 300, sm: 300, md: 300, lg: 300 } : { base: 100 }

  return (
    <>
      <Notifications />
      <AppShell
        className={classes.main}
        navbar={{
          width: opened ? { base: 300, sm: 300, md: 300, lg: 300 } : { base: 100 },
          breakpoint: 'sm',
          collapsed: { mobile: !opened },
        }}
      >
        <SideNavbar
          activePageId={props.pageId}
          setOpened={setOpened}
          opened={opened}
          client={props.client}
          user={props.user}
          role={props.role}
        />
        <AppShell.Main className={classes.mainContainer}>
          <CustomHeader
            user={props.user}
            role={props.role}
            client={props.client}
            subHeader={props.subHeader}
            pageTitle={props.pageTitle}
          />
          <Box className={classes.innerPage} maw={props.fluid ? '100%' : 1600} m='auto' p='xl'>
            {props.status === 'ready' ? props.children : null}
            {props.status === 'loading' ? (
              <Center style={{ minHeight: '100vh' }} h='100vh' mx='auto'>
                <Loader variant='bars' role='alert' aria-label='loading' />
              </Center>
            ) : null}
            {props.status === 'error' ? props.message : null}
          </Box>
          <Footer />
        </AppShell.Main>
      </AppShell>
    </>
  )
}
